"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n"], ["\n  margin: 0;\n  padding: 0;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoySocialShare = require("buoy-social-share");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var List = _styledComponents2.default.div.withConfig({
  displayName: "Social__List",
  componentId: "sc-1qsvbhj-0"
})(_templateObject);

var Social = function Social() {
  return _react2.default.createElement(
    List,
    null,
    _react2.default.createElement(_buoySocialShare.Facebook, {
      margin: "0 15px 0 0",
      link: "https://www.facebook.com/buoyhealth/",
      fillColor: "neutralDarker"
    }),
    _react2.default.createElement(_buoySocialShare.Twitter, {
      margin: "0 15px 0 0",
      link: "https://twitter.com/buoyhealth",
      fillColor: "neutralDarker"
    }),
    _react2.default.createElement(_buoySocialShare.Instagram, {
      margin: "0 0 0 0",
      link: "https://www.instagram.com/buoyhealth",
      fillColor: "neutralDarker"
    }),
    _react2.default.createElement(_buoySocialShare.Linkedin, {
      margin: "0 0 0 0",
      link: "https://www.linkedin.com/company/buoyhealth/",
      fillColor: "neutralDarker"
    })
  );
};

exports.default = Social;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-footer/dist/components/Social.js
// module id = 410
// module chunks = 168707334958949